import { MantineDataTable,
    DataTableTokenPagination,
} from '@flexinet/ui-components';
import { Stack } from '@mantine/core';
import { useAllPersonas } from '../hooks/useAllPersonas';
import { usePersonasTableColumns } from '../hooks/usePersonasTableColumns';
import { useRef } from 'react';

export const PersonasTable = () => {
    const { visibleItems, loading, nextToken, fetchRecords, isFetchingNextPage, visibleCount } = useAllPersonas();
    const columns = usePersonasTableColumns();
    const scrollViewportRef = useRef<HTMLDivElement>(null);

    return (
        <Stack gap="lg">
            <MantineDataTable
                columns={columns}
                records={visibleItems}
                fetching={loading}
                withTableBorder={true}
                onScrollToBottom={fetchRecords}
                scrollViewportRef={scrollViewportRef}
            />
            <DataTableTokenPagination
                loadedCount={visibleCount}
                nextToken={nextToken}
                handleLoadMore={fetchRecords}
                isFetchingMore={isFetchingNextPage}
            />
        </Stack>
    );
};
